export default __webpack_public_path__ + "static/media/Ferrari.208d5422.png";